import { ClientOutput } from "@src/global_functions/backpackSdk/client";

export const supportedRentableSpaceTypes = [
  "Office",
  "BankBranch",
  "DataCenter",
  "Education",
  "FinancialOffice",
  "Hotel",
  "MedicalOffice",
  "Restaurant",
  "RetailStore",
  "Storage",
  "Other",
] as const satisfies Readonly<ClientOutput["tenantsAndSpaces"]["SpaceType"][]>;
